let listGroupFacilities = require('od-modules/data/list_groups_facilities');
const Flights = require('od-apps/app.flights');
const Acc = {};

Acc.searchParamsDefaults = {
    'numberOfRooms': 1,
    'checkInDate': '',
    'checkOutDate': '',
    'rooms': [{
        'numAdults': 2,
        'kidsAges': [],
        'infantsAges': [],
    }],
};

Acc.allocateRooms = function(data) {
    var roomSetUp = Flights.validateRooms(data);
    var numberOfRooms = roomSetUp.length;
    var roomItemSetUp;
    var getObjRoomSetUp = function(roomSetUp) {
        return {
            nAdults: +roomSetUp[0],
            nKids: +roomSetUp[1],
            nInfants: +roomSetUp[2],
        };
    };
    var updateChildPerRoom = function(memo, key, val) {
        if (val > 0) {
            memo[key] = val;
        }
    };

    return {
        numberOfRooms: numberOfRooms,
        rooms: Odigeo._.reduce(Odigeo._.range(0, numberOfRooms), function(memo, nRoom) {
            roomItemSetUp = getObjRoomSetUp(roomSetUp[nRoom].split('_'));
            memo['roomAdults' + nRoom] = roomItemSetUp.nAdults;

            updateChildPerRoom(memo, 'roomKids' + nRoom, roomItemSetUp.nKids);
            updateChildPerRoom(memo, 'roomInfants' + nRoom, roomItemSetUp.nInfants);

            Odigeo._.extend(memo, updateChildsInfo({}, {
                // Order must correspond between aliases, number and default age.
                aliases: ['Kid', 'Infant'],
                number: [roomItemSetUp.nKids, roomItemSetUp.nInfants],
                defaultAge: [6, 1],
            }, nRoom));

            return memo;
        }, {}),
    };
};

Acc.searchParamsParser = function(p) {
    var search = Odigeo._.clone(Acc.searchParamsDefaults);
    var matchesAdultsRooms = p.match(/roomAdults[0-3]=/gi);
    var numRooms = matchesAdultsRooms ? matchesAdultsRooms.length : 0;
    var checkInMatch = p.match(/checkInDate=(\d{4}-\d{2}-\d{2})($|;)/i);
    var checkOutMatch = p.match(/checkOutDate=(\d{4}-\d{2}-\d{2})($|;)/i);
    var providerId = p.match(/providerId=(\w{2})($|;)/i);
    var providerHotelId = p.match(/providerHotelId=(\d{1,12})($|;)/i);
    var dedupId = p.match(/dedupId=(\d{1,12})($|;)/i);
    var searchId = p.match(/searchId=(\d{1,12})($|;)/i);
    var roomsId = p.match(/roomsId=(.+?)($|;)/i);
    var getAgesArray = function(str, regexp) {
        var arr = [];
        var match = regexp.exec(p);
        while (!Odigeo._.isNull(match)) {
            arr.push(+(match[1]));
            match = regexp.exec(p);
        }
        return arr;
    };

    search.rooms = Odigeo._.reduce(Odigeo._.range(numRooms), function(memo, val) {
        var regexp = new RegExp('roomAdults' + val + '=([1-4])(;|$)', 'i');
        // there should always be a match.
        var numAdults = p.match(regexp)[1];
        var infantsAges = getAgesArray(p, new RegExp('room' + val + 'Infant[0-1]Age=([0-2])(;|$)', 'gi'));
        var kidsAges = getAgesArray(p, new RegExp('room' + val + 'Kid[0-1]Age=([2-9]|10|11)(;|$)', 'gi'));

        return memo.concat({
            numAdults: +numAdults,
            kidsAges: kidsAges,
            infantsAges: infantsAges,
        });
    }, []);

    if (Odigeo._.isEmpty(search.rooms)) {
        search.rooms = Odigeo._.clone(Acc.searchParamsDefaults.rooms);
    }
    search.numAdults = Odigeo._.reduce(Odigeo._.pluck(search.rooms, 'numAdults'), Odigeo._.add, 0);
    search.numberOfRooms = search.rooms.length;
    search.checkInDate = !Odigeo._.isNull(checkInMatch) ? checkInMatch[1] : '';
    search.checkOutDate = !Odigeo._.isNull(checkOutMatch) ? checkOutMatch[1] : '';
    search.externalSelectionRequest = {
        providerId: !Odigeo._.isNull(providerId) ? providerId[1] : '',
        providerHotelId: !Odigeo._.isNull(providerHotelId) ? providerHotelId[1] : '',
        dedupId: !Odigeo._.isNull(dedupId) ? dedupId[1] : '',
        searchId: !Odigeo._.isNull(searchId) ? searchId[1] : '',
    };

    if (roomsId) search.externalSelectionRequest.roomsId = window.decodeURIComponent(roomsId[1]);

    return search;
};

Acc.searchParamsStringify = function(params) {
    var finalPassengersNum = {};
    var normalizedObj = normalizeParamsObject(params, finalPassengersNum);
    return {
        updatedParamObj: Odigeo._.extend(params, finalPassengersNum),
        stringifiedParams: Odigeo._.chain(normalizedObj)
            .reduce(function(memo, val, key) {
                return memo + key + '=' + val + ';';
            }, '')
            .tap(encodeURI)
            .value()
            .slice(0, -1),
    };
};

// Order is important: [nAdults, nKids, nInfants]
Acc.updatePassengersNum = function(memo, nPassengers) {
    var nPassengersFiltered = Odigeo._.reduce(nPassengers, function(memo, val) {
        var age = Odigeo._.isNaN(+val) ? 0 : +val;
        return memo.concat(age);
    }, []);

    memo.numAdults = memo.numAdults + nPassengersFiltered[0] || nPassengersFiltered[0];
    memo.numChildren = memo.numChildren + nPassengersFiltered[1] || nPassengersFiltered[1];
    memo.numInfants = memo.numInfants + nPassengersFiltered[2] || nPassengersFiltered[2];
};

function normalizeParamsObject(params, finalPassengersNum) {
    // Order of the properties of this object affects order of the parameters in the string
    var keyMap = {
        checkInDate: 'checkInDate',
        checkOutDate: 'checkOutDate',
        rooms: 'rooms',
        providerId: 'providerId',
        providerHotelId: 'providerHotelId',
        roomsId: 'roomsId',
        dedupId: 'dedupId',
        newSearchId: 'newSearchId',
    };
    var pickedParams = Odigeo._.pick(params, Odigeo._.keys(keyMap));
    var numRooms = params.numberOfRooms || 0;
    var hasProviders = !Odigeo._.isUndefined(params.providerId) && !Odigeo._.isUndefined(params.providerHotelId);

    return Odigeo._.reduce(pickedParams, function(memo, val, key) {
        switch (key) {
            case 'checkInDate':
            case 'checkOutDate':
            case 'dedupId':
            case 'newSearchId':
                if (!Odigeo._.isUndefined(val)) {
                    memo[key] = val;
                }
                break;
            case 'rooms':
                val = normalizeRoomsFormat(val);
                Odigeo._.each(Odigeo._.range(numRooms), function(nVal) {
                    var roomAdults = 'roomAdults' + nVal;
                    var numAdults = val[roomAdults];
                    var roomInfants = 'roomInfants' + nVal;
                    var numInfants = val[roomInfants];
                    var roomKids = 'roomKids' + nVal;
                    var numKids = val[roomKids];

                    Acc.updatePassengersNum(finalPassengersNum, [numAdults, numKids, numInfants]);
                    memo[roomAdults] = numAdults;
                    Odigeo._.extend(memo, updateChildsInfo(val, {
                        // Order must correspond between aliases and number.
                        aliases: ['Kid', 'Infant'],
                        number: [numKids, numInfants],
                    }, nVal));
                });
                break;
            case 'providerId':
            case 'providerHotelId':
                if (!Odigeo._.isUndefined(val) && hasProviders) {
                    memo[key] = val;
                }
                break;
            case 'roomsId':
                if (!Odigeo._.isUndefined(val)) {
                    memo[key] = window.encodeURIComponent(val);
                }
                break;
            default:
                break;
        }

        return memo;
    }, {});
}

function updateChildsInfo(rooms, childInfo, roomNumber) {
    return Odigeo._.reduce(childInfo.aliases, function(memo, typeOfChild, childInfoIndex) {
        Odigeo._.each(Odigeo._.range(childInfo.number[childInfoIndex]), function(n, childNumber) {
            var roomAge = 'room' + roomNumber + typeOfChild + childNumber + 'Age';
            memo[roomAge] = (!Odigeo._.isUndefined(rooms[roomAge])) ? rooms[roomAge] : childInfo.defaultAge[childInfoIndex];
        });
        return memo;
    }, {});
}

function normalizeRoomsFormat(rooms) {
    // Two cases: 1. Already transformed to the proper format (it comes from a deep link). 2. Old format (comes from a form).
    if (Odigeo._.isArray(rooms)) {
        return Odigeo._.reduce(rooms, function(memo, val, index) {
            // Case we came from a secured page
            if (Odigeo._.isUndefined(val.infantsAges) && Odigeo._.isUndefined(val.kidsAges)) {
                updateChildrenPerRoom(val);
            }

            memo['roomAdults' + index] = val.numAdults;
            memo['roomInfants' + index] = val.infantsAges.length;
            memo['roomKids' + index] = val.kidsAges.length;

            Odigeo._.each(Odigeo._.range(memo['roomInfants' + index]), function(n, index2) {
                memo['room' + index + 'Infant' + index2 + 'Age'] = val.infantsAges[index2];
            });

            Odigeo._.each(Odigeo._.range(memo['roomKids' + index]), function(n, index2) {
                memo['room' + index + 'Kid' + index2 + 'Age'] = val.kidsAges[index2];
            });

            return memo;
        }, {});
    }

    return rooms;
}

function updateChildrenPerRoom(room) {
    room.infantsAges = [];
    room.kidsAges = [];
    Odigeo._.each(room.childrenAges, function(childrenAge) {
        if (childrenAge < 2) {
            room.infantsAges.push(childrenAge);
        } else {
            room.kidsAges.push(childrenAge);
        }
    });
}

Acc.getPaxNumBasedOnRooms = function(rooms, numberOfRooms) {
    var paxInfo = {};
    Odigeo._.each(Odigeo._.range(numberOfRooms), function(roomNumber) {
        var numAdults = rooms['roomAdults' + roomNumber];
        var numKids = rooms['roomKids' + roomNumber];
        var numInfants = rooms['roomInfants' + roomNumber];
        Acc.updatePassengersNum(paxInfo, [numAdults, numKids, numInfants]);
    });
    return paxInfo;
};

Acc.convertFacilities = function(facilities, newListGroupFacilities) {
    listGroupFacilities = newListGroupFacilities || listGroupFacilities;

    return Odigeo._.reduce(facilities, mapGroupFacility, {});
};

function mapGroupFacility(groupFacilities, facility) {
    var index = findIndexGroupFacilities(parseInt(facility.code, 10));

    groupFacilities[index] = Odigeo._.isUndefined(groupFacilities[index]) ? [facility] : groupFacilities[index].concat(facility);

    return groupFacilities;
}

function findIndexGroupFacilities(code) {
    var numGroup = -1;

    Odigeo._.find(listGroupFacilities, function(group, index) {
        numGroup = index;
        return Odigeo._.includes(group, code);
    });

    return numGroup;
}

module.exports = Acc;
